import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const RowWrapper = styled.div`
    box-sizing: border-box;
    width: 50vw;
    display: flex;
    justify-content: space-between;
    border-bottom: ${props => props.type === 'header' ? '1px solid #3fa9b4' : '1px solid'}; 
    height: 25px;
    align-items: center;
    height: 60px;
    & > div {
        color: ${props => props.type === 'header' ? '#3fa9b4' : '#afafaf'}
        font-size: ${props => props.type === 'header' ? '12px' : '16px'} 
        font-weight: 200;
    }
`
const RowItemWrapper = styled.div`
    width: ${props => props.type === 'value' ? `${1/props.size * 100}%` :  `${1/(props.size/2) * 100}%`};
    display: flex;
    justify-content: ${props => props.type ==='actions' ? 'space-around' : 'space-between'};
    align-content: center;
    padding-left: 1em;
`

const ClientTableRow = ({type, values, actions}) => {
    let valueLength = values ? values.length : 1
    return(
        <RowWrapper type={type}>
            { values && values.map( (value, index) => 
                <RowItemWrapper 
                    key={`${value}${index}`} 
                    type={'value'} 
                    size={valueLength}
                >
                    {value}
                </RowItemWrapper>  
            )}
            <RowItemWrapper 
                type={'actions'} 
                size={valueLength}
            >
                {actions}
            </RowItemWrapper>  
        </RowWrapper>
    )
}

ClientTableRow.propTypes = {
    /** Type string that defines the styling */
    type: PropTypes.string,
    /** Array of values to be displayed on the row */
    values: PropTypes.array,
    /** Array of actions to be displayed on the row */
    actions: PropTypes.array
}

ClientTableRow.defaultProps = {
    type: 'default',
    values: [],
    actions: []
}

export default ClientTableRow;


// WEBPACK FOOTER //
// ./src/js/containers/CompanyContainer/ClientTableRow.jsx